<template>
  <div class="room-navigator-wrap">
    <i class="back" @click="$router.go(-1)"></i>
    <!-- <i class="setting" @click="$emit('setting')"></i> -->
  </div>
</template>

<script>
export default {

};
</script>

<style lang="less" scoped>
.room-navigator-wrap {
    height: 56px;
    /* background-color: pink; */
    padding: 0 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-shrink: 0;
    .back {
      .iconMixin({
        background-image: url('~@/assets/images/icon/back.png');
      })
    }
    .setting {
      .iconMixin({
        background-image: url('~@/assets/images/icon/setting-dot.png');
      })
    }

}
</style>
